/* eslint-disable consistent-return */
/* eslint-disable no-underscore-dangle */
import { useContext } from 'react';

import { useMutation } from '@apollo/client';

import { GeneralContext } from '../../app-context/GeneralContext';
import { REGISTER_KEYCLOAK_USER } from './graphql';

export function useActivateUserOnResource() {
  const { setErrorMessage } = useContext(GeneralContext);
  const [RegisterKeycloakUser, { loading: apiLoading }] = useMutation(
    REGISTER_KEYCLOAK_USER,
    { fetchPolicy: 'network-only' },
  );

  async function activateUserOnResource({
    keycloakUserId,
    firstName,
    lastName,
    email,
  }) {
    try {
      const res = await RegisterKeycloakUser({
        variables: {
          user: {
            keycloakUserId,
            firstName,
            lastName,
            email,
          },
        },
      });
      if (res.data.registerKeycloakUser.code !== 200) {
        return false;
      }
      return true;
    } catch (e) {
      setErrorMessage('Algo deu errado, tente novamente mais tarde.');
    }
  }

  return {
    activateUserOnResource,
    loading: apiLoading,
  };
}
